<script>
  import { generateRandomString } from '$lib/utils/stringUtils';

  /** @type string */
  export let id;

  /** @type string */
  export let name;

  /** @type boolean */
  export let checked = false;

  let randomString = generateRandomString(8);

  export let onCheckboxChange = (/** @type any */ event, /** @type string */ id) => {};

  function handleChange(/** @type any */ event) {
    onCheckboxChange(event, id);
  }
</script>

<div class="form-check d-flex align-items-center">
  <input
    class="form-check-input"
    type="checkbox"
    id={randomString}
    value={name}
    bind:checked
    on:change={handleChange}
  />
  <label class="form-check-label" for={randomString} data-bs-toggle="tooltip" title={name}>
    {name}
  </label>
</div>

<style>
  .form-check {
    margin-bottom: 10px;
  }

  .form-check-input {
    width: 1.5em;
    height: 1.5em;
  }

  .form-check-label {
    padding-top: 3px;
    padding-left: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .form-check-input:checked {
    background-color: transparent;
    border-color: var(--white);
  }

  .form-check-input:hover {
    border-color: var(--white);
  }

  .form-check-input:focus {
    border-color: var(--white);
    outline: 0;
    box-shadow: 0 0 0 0.25rem var(--grey-15);
  }
</style>
